import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CreatorNavigationComponent } from '../../creator-navigation/creator-navigation.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    CreatorNavigationComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  private readonly router = inject(Router);

  protected isImmersiveBuilderRoute(): boolean {
    const path = this.currentUrlPath();
    return (
      path.startsWith('/quick-edit') ||
      path.startsWith('/quick-tools/') ||
      path.startsWith('/image-editor')
    );
  }

  /** Super Editor and Smart Video New occupy the full viewport without navigation chrome. */
  protected isSuperEditorRoute(): boolean {
    const path = this.currentUrlPath();
    return path.startsWith('/super-editor') || path.startsWith('/video-gen-new');
  }

  protected useCreatorShell(): boolean {
    const path = this.currentUrlPath();
    return (
      !this.isImmersiveBuilderRoute() &&
      !this.isSuperEditorRoute() &&
      !this.isEcommerceBuilderRoute() &&
      !path.startsWith('/onboarding')
    );
  }

  private currentUrlPath(): string {
    return this.router.url.split(/[?#]/)[0];
  }

  private isEcommerceBuilderRoute(): boolean {
    return /^\/ecommerce\/pages\/[^/]+\/builder(?:\/.*)?$/.test(this.currentUrlPath());
  }

}
